var modules_b8cc600d = {"container":"_53y824","textarea":"_uxoo2j","with-icon":"_1ls2t7m","hide-menu":"_y20n1a","icon":"_mv13z1","focus":"_kknmm8"};
import "../../../assets/JVGyT4gQ.css";

export { modules_b8cc600d as default };
//# sourceMappingURL=Autocomplete.module.less.js.map
